import React, {useEffect} from 'react';
import {
    HashRouter as Router,
    Switch,
    Route
} from 'react-router-dom';
import Form from '../register/process/Form';
import Success from '../register/process/steps/Success';
import useWindowSize from '../registered/companyList/search/windowResize';
import FormLarge from '../register/process/FormLarge';
import FindCompany from "../registered/FindCompany";
import AlreadyRegistered from '../registered/AlreadyRegistered';
import { useDispatch } from 'react-redux';
import { settingsAdded } from '../../store/reducers/registrationSettingsReducer';

function Layout() {
    const size = useWindowSize();
    const dispatch = useDispatch();
    const fetchInfo = () => {
        return fetch("https://offshorequalific.no/wp-json/wp/v2/registration-settings")
        .then((res) => res.json())
        .then((d) => dispatch(settingsAdded(d)))
    }
    useEffect(() => { 
        fetchInfo();
    }, []); // eslint-disable-line

    return (
        <Router>
            <Switch>
                <Route path="/" exact component={FindCompany} />
                <Route path="/huri" exact component={FindCompany} />
                <Route path="/success" component={Success} />
                <Route path="/alreadyRegistered" component={AlreadyRegistered} />
                {size.width >= 1100
                    ?
                        <>
                            <Route path="/form" component={FormLarge} />
                        </>
                    :
                        <>
                            <Route path="/form" component={Form} />
                        </>
                }
            </Switch> 
        </Router>
    );
}

export default Layout;
